document.querySelectorAll('.about-faq__title').forEach((aboutNode) => {
    aboutNode.addEventListener('click', () => {
        aboutNode.parentElement.classList.toggle('about-faq__node_selected')
    })
})

document.querySelectorAll('.delivery-node__detail').forEach((aboutNodeDetailLink) => {
    aboutNodeDetailLink.addEventListener('click', () => {
        aboutNodeDetailLink.parentNode.classList.add('delivery-node_show')
    })
})

document.querySelectorAll('.delivery-node-close').forEach((aboutNodeModalClose) => {
    aboutNodeModalClose.addEventListener('click', () => {
        aboutNodeModalClose.parentElement.parentElement.parentElement.classList.remove('delivery-node_show')
    })
})

document.querySelectorAll('.delivery-node-blackmask').forEach((aboutNodeModalClose) => {
    aboutNodeModalClose.addEventListener('click', () => {
        aboutNodeModalClose.parentElement.parentElement.classList.remove('delivery-node_show')
    })
})